import React, { useState } from "react";
import { Container, Row, Col, Button, Label } from 'reactstrap';
import { withStyles, Card } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import SharesGetter from '../../Controller/getShares.js';
import PatientFunctionsGetter from '../../Controller/getSQLPatientFunctions.js';
import axios from "axios";
import rateLimit from 'axios-rate-limit';
import {FormattedMessage} from 'react-intl';

const DeleteShare = (props) => {

    const [message, setMessage] = useState(props.message);
    const [displayButton, setDisplayButton] = useState(true);

    /**Function calling the fetch delete function and closing the popup when the user decids to validate the delete*/
    const deleteSharing  = async () => {
        //setDisplayButton(false);

        setMessage(<FormattedMessage id="share.remove" defaultMessage="Removing share, please wait..." />);
        setDisplayButton(false);
        
        let updatedPatient = props.patient;

        let ret = false
        let test_delete_share = false
        if (props.mailToUnshare === props.patient.Patient_Data.FK_User_mail) {
            test_delete_share = await SharesGetter.stop_Shares(props.accountInformation.email, props.patient.Patient_Data.id_patient)
        }
        else {
            test_delete_share = await SharesGetter.stop_Shares(props.mailToUnshare, props.patient.Patient_Data.id_patient)
        }
        if (test_delete_share === true) {
            if (props.patient.Patient_Data.monitoring_activation !== 'no') {
                props.subscription_info.sub_used -= 1
            }


            //TEMP: A SEPARER DANS UNE FONCTION?
            //Dissociate devices associated with the patient while deleting the shares.
            updatedPatient.Patient_Data.devices.device1.id_old = updatedPatient.Patient_Data.devices.device1.id;
            updatedPatient.Patient_Data.devices.device1.id = "dissociate";
            updatedPatient.Patient_Data.devices.device2.id_old = updatedPatient.Patient_Data.devices.device2.id;
            updatedPatient.Patient_Data.devices.device2.id = "dissociate";
            updatedPatient.Patient_Data.devices.device3.id_old = updatedPatient.Patient_Data.devices.device3.id;
            updatedPatient.Patient_Data.devices.device3.id = "dissociate";
            updatedPatient.Patient_Data.devices.gateway.id_old = updatedPatient.Patient_Data.devices.gateway.id;
            updatedPatient.Patient_Data.devices.gateway.id = "dissociate";

            updatedPatient.Patient_Data.group = null;

            updatedPatient.Patient_Data.monitoring_activation = "no";
            updatedPatient.Patient_Data.shares.id_structure = null;

            if (await PatientFunctionsGetter.update_SQL_patient(updatedPatient) === false) {
                console.log("error updating device gateway patient req")
                setMessage(<FormattedMessage id="message.error.delshare.update" defaultMessage="Oups, did not work... (err_code delshare_update)" />);
            }
            else {
                setMessage(<FormattedMessage id="message.success" defaultMessage="Success!" />);
            }

        }
        else {
            console.log("error deleting share")
            setMessage(<FormattedMessage id="message.error.delshare" defaultMessage="Oups, did not work..." />);
        }
        props.closeAfterUnshare();
    }

    /**Return validation popup display*/
    const { classes } = props;

    return(
    	<div className={classes.popup_background}>
            <Container style={{ height: "100%", width: "100%" }} fluid>
                <Row style={{ height: "100%", width: "100%" }} noGutters>
                    <Col xs="1" md="3" lg="4"></Col>
                        <Col xs="10" md="6" lg="4" style={{ height: "100%", display: "grid", placeItems: "center" }}>
                            <Card className={classes.popup} style={{ overflowY: "auto" }}>
                               	<br/>
                               	    <Row>
                               	    	<Label style={{ fontSize:"1.2em", fontWeight: "bold", textAlign: "center" }}>{message}</Label>
                               	    </Row>
                               	<br/>
                                {displayButton ?
                                    <Row style={{ flex: "0 1 auto" }} noGutters>
                                        <Col xs="12" sm="3" style={{ textAlign: "center" }}>
                                            <Button onClick={() => props.cancelPopup("")} outline color="danger" style={{ marginTop: "0.2em", width: "6em" }}>
                                                <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                                            </Button>
                                        </Col>
                                        <Col xs="" sm="6"></Col>
                                        <Col xs="" sm="3" style={{ textAlign: "center" }}>
                                            <Button onClick={deleteSharing} outline color="success" style={{ marginTop: "0.2em", width: "6em" }}>
                                                <FormattedMessage id="button.validate" defaultMessage="Validate" />
                                            </Button>
                                        </Col>
                                    </Row>
                                    :
                                    null
                                }
                            </Card>
                        </Col>
                    <Col xs="1" md="3" lg="4"></Col>
                </Row>
            </Container>
        </div>
    );
}
export default withStyles(Constants.styles)(DeleteShare);